import { Slide, LinearProgress } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import CheckBox from '../../../Components/CheckBox/CheckBox';
import Modal from '../../../Components/Modal/Modal';
import { Button, Input } from '../../../Components/StyledComponents';
import './MenuImage.scss';
import axios from 'axios';
import { getCroppedImg } from './canvasUtils'
import Cropper from 'react-easy-crop'
import { alertRef } from '../../../App';
import { tableOrderSync } from '../../../Utils/services';

const MenuImage = () => {
    const [isDrag, setIsDrag] = React.useState(false)
    const [list, setList] = React.useState([])
    const [isSent, setIsSent] = React.useState(false)
    const [crop, setCrop] = useState({ x: 0, y: 0, width: 1280, height: 1280 })
    const [selectedGroupId, setSelectedGroupId] = React.useState('');
    const [selectedMenuId, setSelectedMenuId] = React.useState('');
    const [imageSrc, setImageSrc] = React.useState(null)
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [tempZooon, setTempZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null)
    const [isLoading, setIsLoading] = React.useState(true)

    const imageRef = useRef(null);

    useEffect(() => {
        getMenuGroup();
    }, [])

    const getMenuGroup = () => {
        setIsLoading(true)
        axios.get('/api/table/order/menu/group')
            .then((data) => {
                setList(data.data)
                setIsLoading(false)
            })
            .catch(() => {
                setIsLoading(false)
            })
    }

    const modalRef = React.useRef(null);

    const reqUpload = async () => {
        if (!isSent) {
            setIsSent(true)
            let buffer = await getCroppedImg(imageSrc, croppedAreaPixels, rotation)
            getUploadURL(buffer)
        }
    }

    const getUploadURL = (image) => {
        axios.get('/api/table/order/menu/image/' + selectedGroupId + '/' + selectedMenuId)
            .then((data) => {
                if (data.status === 200) {
                    uploadImage(image, data.data.UploadURL, data.data.FileName)
                }
            })
            .catch(() => {
                setIsSent(false)
                alertRef.current.showAlert({ title: '다시 시도해 주세요', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const uploadImage = (image, url, fileName) => {
        axios({
            method: 'PUT',
            url: url,
            headers: {
                'Content-Type': 'image/jpeg',
                'x-amz-acl': 'public-read',
            },
            data: image
        })
            .then((data) => {
                if (data.status === 200) {
                    sendResult(fileName)
                }
            })
            .catch(() => {
                setIsSent(false)
                alertRef.current.showAlert({ title: '다시 시도해 주세요', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const sendResult = (fileName) => {
        axios.post('/api/table/order/menu/image/' + selectedGroupId + '/' + selectedMenuId, {
            FileName: fileName
        })
            .then((data) => {
                if (data.status === 204) {
                    getMenuGroup()
                    setSelectedGroupId('');
                    setImageSrc(null)
                    setIsSent(false)
                    setCroppedAreaPixels(null)
                    modalRef.current.closeModal();
                    alertRef.current.showAlert({ title: '이미지 업로드가 완료되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                setIsSent(false)
                alertRef.current.showAlert({ title: '다시 시도해 주세요', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        if (croppedAreaPixels.width < 1280 || croppedAreaPixels.height < 1280) setZoom(tempZooon)
        else setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]
            //let imageDataUrl = await readFile(file)

            const reader = new FileReader()
            reader.addEventListener('load', (e) => {
                setImageSrc(reader.result.toString() || '')
            })
            reader.readAsDataURL(e.target.files[0])
        }
    }

    const createImage = (url) =>
        new Promise((resolve, reject) => {
            const image = new Image()
            image.addEventListener('load', () => resolve(image))
            image.addEventListener('error', (error) => reject(error))
            image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
            image.src = url
        })

    const onLoad = async (event) => {
        const image = await createImage(imageSrc)
        if (image.naturalHeight < 1280 || image.naturalWidth < 1280) {
            alertRef.current.showAlert({ title: '1280*1280 사이즈 이상의 이미지만 업로드 가능합니다.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            setImageSrc(null)
            return;
        }
    }

    const openImageModal = (gid, id, img) => {
        if (img !== '') setImageSrc('https://cdn.syrupfriends.com/Images/Menu/' + img)
        setSelectedGroupId(gid);
        setSelectedMenuId(id);
        modalRef.current.openModal()
    }

    const onZoomChange = (val) => {
        setTempZoom(zoom)
        setZoom(val)
    }

    const deleteImage = (menuId, id) => {
        axios.delete(`/api/table/order/menu/image/${menuId}/${id}`)
            .then((data) => {
                if (data.status === 204) {
                    getMenuGroup()
                    alertRef.current.showAlert({ title: '이미지 삭제가 완료되었어요.', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title: '다시 시도해 주세요', isConfirm: true, confirmText: '확인', onConfirm: () => alertRef.current.hideAlert() })
            })
    }

    return (
        <div className='menu-soldout-info'>            
            <div className='header-row between'>
                <div />
                <Button variant="sub" small style={{ width: 112 }} onClick={() => tableOrderSync()}>
                    메뉴 동기화
                </Button>
            </div>
            {/*<p className='img-warn-text'>* 등록/수정 요청한 이미지는 본사에서 검수 후 노출 됩니다.</p>*/}
            {
                isLoading ?
                    <LinearProgress color="error" />
                    :
                    null
            }
            {
                isLoading ?
                    null
                    :
                    list.length > 0 ?
                        list.map((data, i) => (
                            <div className='menu-group-box' key={i}>
                                <div className='row'>
                                    <p className='menu-group-name'>{data.Name.ko}</p>
                                </div>

                                {
                                    data.MenuInfo.map((item, i) => {
                                        return (
                                            <React.Fragment key={i}>
                                                <div className='row between'>
                                                    <div className='row'>
                                                        <Slide direction='right' in={isDrag} mountOnEnter unmountOnExit style={{ transitionDuration: '0.4s' }}>
                                                            <p className='move-icon' style={{ width: isDrag ? 64 : 0, transition: 'all', transitionDuration: '0.3s' }}>
                                                                <CheckBox containerStyle={{ width: 64, margin: 0, height: 24 }} />
                                                            </p>
                                                        </Slide>
                                                        <div className='row'>
                                                            {
                                                                item.Img !== '' &&
                                                                <img src={"https://cdn.syrupfriends.com/Images/Menu/" + item.Img} className='menu-img' />
                                                            }
                                                            <div className='row'>
                                                                <div>
                                                                    <p className='menu-name'>{item.Name.ko}</p>
                                                                    {/* {
                                                                        (typeof item.ImgCheck !== 'undefined' && item.ImgCheck === 'Reject') &&
                                                                        <p className='reject-reason'>반려 사유 : {item.Reason}</p>
                                                                    } */}
                                                                </div>
                                                                {/* {
                                                                    (typeof item.ImgCheck !== 'undefined' && item.ImgCheck === 'Pending') &&
                                                                    <div className='img-check' style={{ backgroundColor: '#408ADF' }}>
                                                                        검수 중
                                                                    </div>
                                                                } */}

                                                                {/* {
                                                                    (typeof item.ImgCheck !== 'undefined' && item.ImgCheck === 'Reject') &&
                                                                    <div className='img-check'>
                                                                        반려
                                                                    </div>
                                                                } */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row' style={{ alignItems: 'center', justifyContent: 'center', height: isDrag ? 0 : 'fit-content', opacity: isDrag ? 0 : 1, transition: 'all', transitionDuration: '0.5s' }}>
                                                        <button className='mod-btn' style={item.Img !== '' ? {} : { borderRadius: 8 }} onClick={() => openImageModal(data._id.$oid, item._id.$oid, item.Img)}>
                                                            수정하기
                                                        </button>
                                                        {
                                                            item.Img !== '' &&
                                                            <button
                                                                className='remove-btn'
                                                                onClick={() =>
                                                                    alertRef.current.showAlert(
                                                                        {
                                                                            title: `메뉴 이미지를 삭제 하시겠습니까?`,
                                                                            subWarnTitle: '',
                                                                            isConfirm: true, confirmText: '삭제하기',
                                                                            isCancel: true,
                                                                            cancelText: '취소',
                                                                            onConfirm: () => { alertRef.current.hideAlert(); deleteImage(data._id.$oid, item._id.$oid, item.Img) }
                                                                        })
                                                                }>
                                                                <img src={require('../../../aseets/icons/delete.svg').default} style={{ width: 24, height: 24 }} />
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='divider' />
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </div>
                        ))
                        :
                        <div>
                            <p className='empty-list'>생성된 메뉴가 없습니다.</p>
                        </div>
            }

            <Modal ref={modalRef} contentContainer={{ width: 500 }} isHeader title='메뉴 이미지 수정'>
                <div>
                    <p className='label' style={{ width: 'fit-content' }}>메뉴 이미지를 등록해보세요.</p>
                    <p className='warn-soldout'>* 1280 * 1280 사이즈 이상 이미지 파일만 등록 가능해요.</p>
                    {/* <p className='img-warn-text' style={{ textAlign: 'left' }}>* 등록하기 버튼을 누르시면 본사에서 검수 후 노출 되니 다시 한번 확인해 주세요.</p> */}

                    <div className='file-btn' style={{ cursor: 'pointer' }}>
                        <input id="image" type="file" accept="image/*" onChange={onFileChange} onLoadedData={onLoad}></input>
                        <label htmlFor="image">
                            <div className='row' style={{cursor: 'pointer'}}>
                                <img src={require('../../../aseets/icons/plus_pink.svg').default} style={{ width: 24, height: 24, marginRight: 8 }} />
                                이미지 선택하기
                            </div>
                        </label>
                    </div>

                    {imageSrc ? (
                        <React.Fragment>
                            <div style={{ backgroundColor: 'rgba(63,63,63,0.48)', alignItems: 'center', justifyContent: 'center', display: 'flex', marginTop: 24, width: 400, height: 280 }}>
                                <Cropper
                                    image={imageSrc}
                                    crop={crop}
                                    rotation={rotation}
                                    zoom={zoom}
                                    aspect={1}
                                    onMediaLoaded={onLoad}
                                    onCropChange={setCrop}
                                    cropSize={{ width: 280, height: 280 }}
                                    onRotationChange={setRotation}
                                    onCropComplete={onCropComplete}
                                    onZoomChange={onZoomChange}
                                    // objectFit='cover'
                                    style={{
                                        containerStyle: {
                                            position: 'relative',
                                            width: '100%',
                                            height: 280,
                                            background: '#333',
                                        }
                                    }}
                                />
                            </div></React.Fragment>) : null
                    }
                    <div className='btn-row'>
                        <Button variant="main" className='save-btn' fontSize={16} onClick={() => reqUpload()}>
                            등록하기
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}



export default MenuImage;